import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import { fieldLang, getFieldWithLangKey } from '../utils/getFieldFromItem'

// Note: first_name and last_name are JSON columns, can't use $like directly
// Search only on string columns
const searchKeys = [
  'snag',
  'email',
  'tel',
]

export const fetchItems = (params = {}) => async (dispatch) => {
  dispatch({ type: ActionTypes.MEMBERLIST_FETCHITEMS_LOAD })
  try {
    const {
      current = 1,
      pageSize,
      sort = 'created_at',
      order = 'descend',
      search,
    } = params
    const $skip = (current - 1) * pageSize
    const $limit = pageSize
    const $sort = { [sort]: order === 'descend' ? -1 : 1 }
    const $or = (search && searchKeys.map(key => ({ [key]: { $like: `%${search}%` } }))) || null
    const query = {
      $skip,
      $limit,
      $sort,
    }
    $or && (query.$or = $or)
    const result = await api.get('members', query)
    const {
      data: items,
      total,
    } = result
    const nItems = items.map(i => ({
      ...i,
      ...getFieldWithLangKey({ fieldTitle: 'first_name', objString: i.first_name, languages: fieldLang }),
      ...getFieldWithLangKey({ fieldTitle: 'last_name', objString: i.last_name, languages: fieldLang }),
      ...getFieldWithLangKey({ fieldTitle: 'title', objString: i.title, languages: fieldLang }),
    }))
    dispatch({
      type: ActionTypes.MEMBERLIST_FETCHITEMS_SUCCEED,
      items: nItems,
      total,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.MEMBERLIST_FETCHITEMS_FAIL,
      fetchItemsError: error.message,
    })
  }
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.MEMBERLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.MEMBERLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.MEMBERLIST_SEARCHTABLE_EDIT,
    search,
  })
}
